import {IKioskScreen} from './screen';
import {BaseSoftDeletableDocumentType} from "../base-document-types";

export interface ScreenTemplate extends IKioskScreen, BaseSoftDeletableDocumentType {
  title: string;
  description?: string;
}
